/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const dateRangeInputBeanSchema = z.object({
  from: z.nullable(z.iso.date()),
  to: z.nullable(z.iso.date()),
});
